import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const URL_RELATORIOS = `${modulo.ARRECADACAO}/relatorio`

const actions = {
  async dadosCards ({commit}) {
    const data = await axios({
      method: 'get',
      url: `${URL_RELATORIOS}/dadosCards`,
      error: true
    })

    return data
  },

  async dadosGrafico ({commit}, dados) {
    const data = await axios({
      method: 'post',
      url: `${URL_RELATORIOS}/dadosGrafico?tipo=${dados.tipo}&parametro=${dados.parametro}&tipoData=${dados.tipoData}`,
      data: dados.filtro,
      error: true
    })

    return data
  },

  async find ({commit}, dados) {
    const data = await axios({
      method: 'post',
      url: `${URL_RELATORIOS}/findByFilter`,
      data: dados.filtro,
      error: true
    })

    return data
  },

  async exportaCSVArrecadacao ({ commit }, dados) {
    const file = await axios({
      method: 'POST',
      url: `${URL_RELATORIOS}/csv`,
      data: dados,
      responseType: 'blob'
    })

    return file
  },

  async exportaCSVProcessosArrecadacao ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: `${URL_RELATORIOS}/processos/csv`,
      data: filtro,
      responseType: 'blob'
    })

    return file
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/arrecadacao/relatoriosArrecadacao.js